
const clamp = (
  value: number,
  min = Number.MIN_SAFE_INTEGER,
  max = Number.MAX_SAFE_INTEGER) => Math.min(max, Math.max(min, value));

export { clamp };
